import { render, staticRenderFns } from "./TabBarTwo.vue?vue&type=template&id=5cbee675&scoped=true"
import script from "./TabBarTwo.vue?vue&type=script&lang=js"
export * from "./TabBarTwo.vue?vue&type=script&lang=js"
import style0 from "./TabBarTwo.vue?vue&type=style&index=0&id=5cbee675&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbee675",
  null
  
)

export default component.exports